import React from 'react'
import Grid from '@material-ui/core/Grid'
import Content from 'components/shared/Content'

interface IProps {
    sensor: any
}

const style = {
    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
}

const Pack = ({ sensor }: IProps) => (
    <Grid container direction="column">
        <Grid item>
            <Content style={style} label="Pressure" value={`${sensor.sensor1.toFixed(2)/10} bar`} />
        </Grid>
    </Grid>
)

export default Pack